import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { QuantityStripper } from "../../../../Layout/Common/quantityStripper";
import { ConvertToFloat, isValidArray } from "../../../../Layout/Common/common";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { RemoveWhishList } from "./removeWhishList";
import { handleStockStatus } from "../../../../utils/stockStatus";
import { PriceStockPopup } from "../../../../Layout/Common/priceStockPopup";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { ProductLink } from "../../../../Layout/Common/productLink";

export const ProductGridView = ({ data, index, updateList }) => {
  const { CartItem } = useContext(GlobalContext);
  const [productStock, setProductStock] = useState(null);
  const [ProductData, setProductData] = useState(null);
  const [qty, setQty] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const { getProductPrice } = useGlobalFunction();

  useEffect(() => {
    if (data) {
      setProductData(data);
      setProductPrice(data.price);

      fetchProductPrice(data.productId);
      if (data.stockStatus) {
        const status = handleStockStatus(data.stockStatus);
        setProductStock(status);
      }
    }
  }, [data]);

  useEffect(() => {
    if (!ProductData) return;
    if (ProductData && CartItem && isValidArray(CartItem.cartItem)) {
      var products = CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(ProductData.productId));
      setQty({
        prod_id: ProductData.productId,
        qty: filterProductId?.qty ?? 0,
      });
    } else {
      setQty({ prod_id: ProductData?.productId, qty: 0 });
    }
  }, [CartItem, ProductData]);
  const fetchProductPrice = async (productId) => {
    let price = await getProductPrice(productId ?? 0);
    if (price) setProductPrice(ConvertToFloat(price));
  };

  return (
    <Fragment>
      {ProductData && (
        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4" key={ProductData.productId}>
          <div className="product-list" data-id={ProductData.productId} key={ProductData.productId}>
            <div className="product-items">
              <ProductLink to={ProductData.link}>
                <ImageWithDefault src={ProductData.prodImage} alt="product-name" />
              </ProductLink>
              <div className="wishlist-products">
                <div />
                {ProductData.isClearance ? (
                  <small className="product-stage new-clearance">CLEARANCE</small>
                ) : (
                  ProductData.isNew && <small className="product-stage new-product">New</small>
                )}
              </div>
            </div>
            <div className="product-details">
              <h6 className="product-title">
                <ProductLink to={ProductData.link}>{ProductData.description}</ProductLink>
              </h6>
              {productStock && (
                <Fragment>
                  {productStock.isSubstitute ? (
                    <Fragment>
                      <div className="product-price">
                        <div className="product-unavailable fav-product-unavailable">
                          <p>Substituted</p>
                        </div>
                        <RemoveWhishList product={ProductData} />
                      </div>
                      <div className="product-code product-substituted">
                        <p>
                          Replacement:
                          <Link to={productStock.redirectUrl}>{productStock.substituteCode}</Link>
                        </p>
                      </div>
                      <div className="product-button">
                        <button type="button" className="btn btn-products btn-unavailable">
                          Unavailable
                        </button>
                      </div>
                    </Fragment>
                  ) : productStock.isShowBuy == false ? (
                    <Fragment>
                      <div className="product-price">
                        <div className="product-unavailable fav-product-unavailable">
                          <p>Discontinued</p>
                        </div>
                        <RemoveWhishList product={ProductData} />
                      </div>
                      <div className="product-code">Code: {ProductData.productCode}</div>
                      <div className="product-button">
                        <button type="button" className="btn btn-products btn-unavailable">
                          {ProductData.stockStatus.stockStatusRaw}
                        </button>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="product-price">
                        <p>$ {ConvertToFloat(productPrice)} </p>
                        <div className="fav-list-dollar">
                          <RemoveWhishList product={ProductData} updateList={updateList} />
                          <PriceStockPopup product={ProductData} />
                        </div>
                      </div>
                      <div className="product-code">Code: {ProductData.productCode}</div>
                      {qty && (
                        <QuantityStripper
                          prd={qty}
                          params={{
                            code: ProductData.productCode,
                            desc: ProductData.description,
                            img: ProductData.prodImage,
                          }}
                        />
                      )}
                    </Fragment>
                  )}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
